(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tiles"] && !Shopify.designMode) return;
  try {
    
// The custom element also initializes when the theme editor replaces this section.
// MARK:- It owns both the arrow scrolling and the filter-state sync; the legacy subcollections
// fallback renders inside the same element with no grid, so only the sync runs there.
if (!customElements.get('collection-tile-scroller')) {
  customElements.define('collection-tile-scroller', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-section-type="collection-tiles"]');
      this.controller = new AbortController();
      const { signal } = this.controller;
      document.addEventListener('collection:reloaded', () => this.syncFilters(), { signal });
      this.syncFilters();

      this.grid = this.querySelector('.collection-tiles__grid');
      if (!this.grid) return;
      this.previous = this.querySelector('.collection-tiles__arrow--previous');
      this.next = this.querySelector('.collection-tiles__arrow--next');
      this.update = () => this.updateButtons();
      this.previous.addEventListener('click', () => this.scrollTiles(-1), { signal });
      this.next.addEventListener('click', () => this.scrollTiles(1), { signal });
      this.grid.addEventListener('scroll', this.update, { passive: true, signal });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.grid);
      if (this.grid.firstElementChild) this.resizeObserver.observe(this.grid.firstElementChild);
      this.updateButtons();
    }

    disconnectedCallback() {
      this.controller.abort();
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    // Per-tile active state: read the refreshed sidebar's CHECKED filter inputs,
    // which reflect Shopify's real active_values (list/boolean filters). Not the URL —
    // a stale/unsupported param (e.g. a disabled vendor value) lingers in the query
    // string without filtering and would falsely highlight a tile.
    appliedFilters(content) {
      const applied = {};
      content.querySelectorAll('input[name^="filter."]:checked').forEach((input) => {
        (applied[input.name] = applied[input.name] || []).push(input.value);
      });
      return applied;
    }

    // "Any filter applied" must cover EVERY filter type, read entirely from the refreshed
    // DOM (never the URL — see note). Checkbox (list/boolean) filters appear as :checked
    // inputs. PRICE is different: this theme renders it as two readonly text inputs with the
    // range bounds on the container's data-min/data-max (collection-grid-filters-form.liquid
    // :241-265). It is never :checked and gets no remove pill (price_range has no
    // active_values), so detect it by comparing each input's value to its bound.
    anyFilterApplied(content, applied) {
      if (Object.keys(applied).length > 0) return true;
      const price = content.querySelector('.price-range');
      if (price) {
        // Unset price inputs must not count as a filter. Depending on currency formatting an
        // unfiltered input can render "" or a formatted zero ("0.00"); treat both as unset by
        // requiring a value strictly INSIDE the range: min above the lower bound, max below the
        // upper bound AND above the lower bound (a max of 0 is the unset artifact, not "price <= 0").
        // Input values and data-min/data-max share the same money formatting (filters-form:223-238).
        // Shopify exposes range_max but NOT range_min, so data-min is empty -> default the lower bound to 0.
        const lower = parseFloat(price.dataset.min) || 0;
        const upper = parseFloat(price.dataset.max);
        const minInput = price.querySelector('.price-range__input-min');
        const maxInput = price.querySelector('.price-range__input-max');
        const minVal = minInput && minInput.value !== '' ? parseFloat(minInput.value) : NaN;
        const maxVal = maxInput && maxInput.value !== '' ? parseFloat(maxInput.value) : NaN;
        if (!Number.isNaN(minVal) && !Number.isNaN(lower) && minVal > lower) return true;
        if (!Number.isNaN(maxVal) && !Number.isNaN(upper) && maxVal > lower && maxVal < upper) return true;
      }
      return false;
    }

    syncFilters() {
      const content = document.getElementById('CollectionAjaxContent');
      if (!content || !this.root) return;

      // No filter form on this page (e.g. the no-sidebar template disables the sidebar,
      // collection-grid-filters.liquid:11) => there is no AJAX filtering. Leave the
      // server-rendered state (set in Liquid) untouched rather than clobbering it.
      if (!content.querySelector('.filter-form')) return;

      const applied = this.appliedFilters(content);

      this.root.querySelectorAll('.collection-tile__link[data-filter-param]').forEach((link) => {
        const param = link.getAttribute('data-filter-param');
        const value = link.getAttribute('data-filter-value');
        const active = !!applied[param]?.includes(value);
        link.closest('.collection-tile').classList.toggle('collection-tile--active', active);
      });

      if (this.root.classList.contains('collection-tiles--hide-when-filtered')) {
        this.root.classList.toggle('is-filtered', this.anyFilterApplied(content, applied));
      }
    }

    updateButtons() {
      const image = this.grid.querySelector('.collection-tile__image');
      if (image) this.style.setProperty('--tile-arrow-top', `${image.offsetTop + image.offsetHeight / 2}px`);
      const maxScroll = this.grid.scrollWidth - this.grid.clientWidth;
      const overflowing = this.grid.clientWidth > 0 && maxScroll > 1;
      const position = Math.abs(this.grid.scrollLeft);
      this.previous.hidden = this.next.hidden = !overflowing;
      this.previous.disabled = position <= 1;
      this.next.disabled = position >= maxScroll - 1;
    }

    scrollTiles(direction) {
      const tile = this.grid.firstElementChild;
      if (!tile) return;
      const gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
      const directionSign = getComputedStyle(this.grid).direction === 'rtl' ? -1 : 1;
      this.grid.scrollBy({
        left: direction * directionSign * (tile.getBoundingClientRect().width + gap),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
